import { useState } from "react";
import { Provider } from "react-redux";
import { RouterProvider, createRouter } from "@tanstack/react-router";

import ActivityIndicator from "@/components/ui/activity-indicator";
import { createAppStore } from "@/store";

import WebFont from "webfontloader";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

function Init() {

  const [isReady, setIsReady] = useState(false);
  const [fontsLoaded, setFontsLoaded] = useState(false);

  const store = createAppStore(() => {
    setIsReady(true);
    console.log("Store is Ready");
  });

  WebFont.load({
    custom: {
      families: ["Inter:n4,i4,n5,i5,n7,i7"],
        urls: ['/fonts/fonts.css'] // This will load our CSS with @font-face definitions
    },
    loading: function () {
      console.log("WebFont loading");
    },
    inactive: function () {
      setFontsLoaded(true);
      console.log("WebFont inactive");
    },
    active: function () {
      setFontsLoaded(true);
      console.log("WebFont Ready");
    },
  });

  if (!isReady || !fontsLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center">
          <ActivityIndicator />
        </div>
      );
  }

  return <Provider store={store}><RouterProvider router={router} /></Provider>;
}

export default Init;
